export default __webpack_public_path__ + "resources/icons/n332-9abc.webp";